import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import AssetGroupOverviewComponent from './AssetGroupOverviewComponent';
import * as actions from './actions';
import { getModel } from './selectors';
import { setSelectedAssetAction } from '../AssetOverview/actions';

const AssetGroupOverviewContainer = (props) => {
    /*useEffect(() => {
        return () => {
            props.actions.clearStore();
        };
    }, []);*/

    return <LoadingStatusWrapper useCustomAnchor loadingStatus={[
        ...props.generalFilterLoadingStatuses
    ]}>
        <AssetGroupOverviewComponent {...props} />
    </LoadingStatusWrapper>;
};

AssetGroupOverviewContainer.propTypes = {
    actions: PropTypes.shape({
        clearStore: PropTypes.func
    }),
    generalFilterLoadingStatuses: PropTypes.array
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, setSelectedAssetAction }, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetGroupOverviewContainer);
